import React from 'react';
import AppController from './AppController'


class App extends React.Component {

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        
        return ( <AppController /> );

    };
}

export default App;
